import type { BizStatusCode } from '@/config/biz-status'

export const enUSMessages: Record<BizStatusCode, string> = {
  SUCCESS: 'Success',
  AUTH_LOGIN_SUCCESS: 'Signed in successfully',
  AUTH_REGISTER_SUCCESS: 'Registered successfully',
  AUTH_LOGOUT_SUCCESS: 'Signed out',
  AUTH_REFRESH_SUCCESS: 'Token refreshed',
  SMS_SEND_SUCCESS: 'Verification code sent',
  NEWSFLASH_SYNC_SUCCESS: 'Sync completed',
  AUTH_TOKEN_MISSING: 'Please sign in first',
  AUTH_TOKEN_INVALID: 'Invalid credentials',
  AUTH_SESSION_EXPIRED: 'Session expired, please sign in again',
  AUTH_LOGIN_REQUIRED: 'Please sign in first',
  AUTH_UNAUTHORIZED: 'Unauthorized',
  AUTH_REFRESH_INVALID: 'Invalid refresh token, please sign in again',
  AUTH_REFRESH_REUSED: 'Suspicious login detected, please sign in again',
  AUTH_REFRESH_EXPIRED: 'Session expired, please sign in again',
  AUTH_DEVICE_MISMATCH: 'Device verification failed, please sign in again',
  AUTH_ENV_MISMATCH: 'Environment verification failed, please sign in again',
  AUTH_ACCOUNT_DISABLED: 'Account has been disabled',
  AUTH_LOGIN_FAILED: 'Incorrect account or password',
  USER_NOT_FOUND: 'User not found',
  USER_ALREADY_EXISTS: 'Account already exists',
  USER_ACCOUNT_INVALID: 'Please enter a valid phone, email, or username',
  USER_ID_GENERATE_FAILED: 'System busy, please try again later',
  USER_PROFILE_UPDATED: 'Profile updated',
  USER_PASSWORD_UPDATED: 'Password updated',
  AUTH_OLD_PASSWORD_WRONG: 'Incorrect current password',
  CAPTCHA_REQUIRED: 'Please enter the captcha',
  CAPTCHA_INVALID: 'Invalid or expired captcha',
  SMS_DISABLED: 'SMS verification is not available, please use password login',
  SMS_COOLDOWN: 'Too many requests, please try again later',
  SMS_CODE_INVALID: 'Invalid or expired verification code',
  NEWSFLASH_NOT_FOUND: 'Newsflash not found or not synced yet',
  NEWSFLASH_SYNC_FORBIDDEN: 'Sync is not allowed',
  QUOTE_NOT_FOUND: 'Quote symbol not found',
  QUOTE_SYNC_FORBIDDEN: 'Quote sync is not allowed',
  QUOTE_SYNC_SUCCESS: 'Quote sync completed',
  TRADE_NOT_AVAILABLE: 'Trading is coming soon',
  FILE_TYPE_UNSUPPORTED: 'Unsupported file type',
  FILE_SIZE_EXCEEDED: 'File size exceeds the limit',
  VALIDATION_FAILED: 'Validation failed',
  RATE_LIMIT_EXCEEDED: 'Too many requests, please try again later',
  OPERATION_TOO_FREQUENT: 'Too many operations, please try again later',
  FORBIDDEN: 'Forbidden',
  NOT_FOUND: 'Not found',
  API_NOT_FOUND: 'API not found',
  SERVER_ERROR: 'Internal server error',
}
